<template>
  <div class="step">
    <riseup-header/>
    <signup-banner/>

    <div class="content">
      <div class="enter-details">
        <div class="intro">הרשמה</div>
        <div class="title">היי {{ firstName }}!</div>
        <div class="text">כדי לפתוח חשבון התנסות נצטרך את המייל שלך. מבטיחים לא להספים.</div>

        <div class="inputs">
          <email-input
            labelText="אימייל"
            :value="email"
            :onInput="setEmail"
            :error="emailError"
            :onError="setEmailError"/>
        </div>
      </div>

      <div>
        <sun/>
        <div class="enter-details">
          <riseup-button class="cta" :disabled="disabled" title="אפשר להמשיך" :size="'small'" :action="nextClicked"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import RiseupHeader from '@/base-components/app-header/RiseupHeader.vue';
import EmailInput from '@/base-components/EmailInput';
import Segment from '@/Segment';
import BaseUI from 'base-ui';
import { mapMutations, mapState } from 'vuex';
import SignupBanner from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup-v3/steps/SignupBanner';
import Sun from '../../signup-v1/steps/Sun';

export default {
  name: 'EnterEmail',
  components: {
    RiseupHeader,
    EmailInput,
    RiseupButton: BaseUI.RiseupButton,
    Sun,
    SignupBanner,
  },
  props: {
    nextStep: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      emailError: false,
    };
  },
  created() {
    Segment.trackUserGot('SignUp_V3_Email_Entered_Marketing');
    Segment.trackUserGotToPixel('RegistrationEntered_Split_EmailEntered');
  },
  computed: {
    ...mapState('signup', ['firstName', 'email']),
    disabled() {
      return this.email.length < 2 || this.emailError;
    },
  },
  methods: {
    ...mapMutations('signup', ['setEmail']),
    setEmailError(value) {
      this.emailError = value;
    },
    nextClicked() {
      Segment.trackUserInteraction('SignUp_V3_Email_NextClicked_Marketing');
      Segment.trackUserGotToPixel('RegistrationEntered_Split_EmailEntered_NextClicked');
      if (this.emailError) {
        Segment.trackUserGotToPixel('RegistrationEntered_Split_EmailEntered_InvalidEmail');
      } else {
        this.nextStep();
      }
    },
  },
};

</script>
<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '@/scss/mixins';

.step {
  @include white-page-frame;
  height: 100%;

  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .enter-details {

    @include responsive-padding;
    color: $riseup_black;
    width: 100%;

    .intro {
      margin-top: 32px;
      font-size: 18px;
      line-height: 28px;
    }

    .text {
      margin-top: 12px;
      font-size: 18px;
      line-height: 26px;
      width: 100%;
    }

    .title {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 22px;
      line-height: 28px;
      display: inline-block;
      width: 100%;
    }

    .inputs {
      margin-top: 25px;
    }

    .cta {
      margin-top: 30px;
      margin-bottom: 30px;
      width: 100%;
    }
  }

}
</style>
